export default "__VITE_ASSET__a4bfb015__"